import { AppGalleryIcon, AppStoreIcon, GooglePlayIcon, RuStoreIcon } from "../icons";
export var storeVariants = {
  appGallery: AppGalleryIcon,
  googlePlay: GooglePlayIcon,
  appStore: AppStoreIcon,
  ruStore: RuStoreIcon
};